import React, { useEffect, useMemo, useState } from "react";
import i18n from "utils/i18n";
import PreviewTimeslotKind from 'scenes/management/timeslots/timeslot_kind/_components/PreviewTimeslotKind'
import { useNavigation } from '@react-navigation/native'
import _ from 'lodash'
import LoadingComponent from 'components/atoms/Loading'
import ThemedBlock from 'components/atoms/ThemedBlock'
import FetchTimeslotKindLimitations from 'utils/fetch/FetchTimeslotKindLimitations'
import { FormFieldsConstants, FormStatus } from 'utils/constants/form-constants'
import HelperString from 'utils/helper-string'
import Form from 'components/molecules/Form'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import { timeslotKindLimitationCarFuelTypeConstants, timeslotKindLimitationCarTypeConstants } from 'utils/constants/timeslot-kind-limitation-constants.js'
import GraphqlBuilder, { graphqlOptions } from 'utils/request/graphql/builder'
import MutationManagementTimeslotKindLimitation from 'graphql/mutations/management/MutationManagementTimeslotKindLimitation'
import VStack from 'components/atoms/stack/VStack'

const ManagementTimeslotKindLimitationsTab = ( { saveForm, updateTimeslotKind, timeslotKind, isSaving }) => {
	
	const navigation = useNavigation();
	
	const [ loading, setLoading ] = useState( true )
	const [ timeslotKindLimitation, setTimeslotKindLimitation ] = useState( {} )
	const [ updatedValues, setUpdatedValues ] = useState( {} )
	
	const fetch = () => {
		FetchTimeslotKindLimitations.fetch({
			guid: timeslotKind.guid,
			callbackSuccess: result => {
				setTimeslotKindLimitation( result ?? {} )
				setLoading( false )
			},
			callbackError: () => {
				setLoading( false )
			},
			callbackStart: () => {
				setLoading( true )
			}
		})
	}
	
	const onChange = ( values ) => {
		setUpdatedValues({
			...updatedValues,
			...values
		})
	}
	
	const onSubmit = (values, { callback } = {} ) => {
		
		let updatedValues = {
			...values,
			timeslot_kind_guid: timeslotKind.guid
		}
		
		_.forEach( updatedValues, ( value, key ) => {
			if( [ 'timeslot_kind_guid', 'car_type', 'car_fuel_type'].includes( key ) === false) {
				if( !HelperString.isEmptyString( value ) ) {
					updatedValues[ key ] = parseFloat( value )
				} else {
					updatedValues[ key ] = null
				}
			}
		});
		
		new GraphqlBuilder( { [ graphqlOptions.processVariables ]: false })
			.addQuery( 'mutation', MutationManagementTimeslotKindLimitation, updatedValues )
			.setResultPath( ['mutation', 'timeslot_kind_limitation'], {} )
			.setOnStart( () => {
				callback( FormStatus.LOADING )
			})
			.setOnSuccess( ( result ) => {
				callback( FormStatus.SUCCESS );
				fetch();
			})
			.setOnError( ( result ) => {
				callback( FormStatus.ERROR )
			})
			.execute()
	}
	
	useEffect( () => {
		return fetch();
	}, [] )
	
	const formFields = useMemo( () =>{
		return [
			{
				name: 'car_type',
				label: i18n.t('management:form.limitation_car_type.title'),
				type: FormFieldsConstants.SELECT_MULTI,
				options: _.map( timeslotKindLimitationCarTypeConstants, o => {
					return {
						value: o,
						label: i18n.t( `management:form.limitation_car_type.${ o }`)
					}
				})
			},
			{
				name: 'car_fuel_type',
				label: i18n.t('management:form.limitation_car_fuel_type.title'),
				type: FormFieldsConstants.SELECT_MULTI,
				options: _.map( timeslotKindLimitationCarFuelTypeConstants, o => {
					return {
						value: o,
						label: i18n.t( `management:form.limitation_car_fuel_type.${ o }`)
					}
				})
			},
			{
				name: 'car_length_max',
				label: i18n.t('management:form.car_length_max.title') + ' (cm)',
				type: FormFieldsConstants.NUMBER
			},
			{
				name: 'car_width_max',
				label: i18n.t('management:form.car_width_max.title') + ' (cm)',
				type: FormFieldsConstants.NUMBER
			},
			{
				name: 'car_height_max',
				label: i18n.t('management:form.car_height_max.title') + ' (cm)',
				type: FormFieldsConstants.NUMBER
			},
			{
				name: 'car_wheelbase_max',
				label: i18n.t('management:form.car_wheelbase_max.title') + ' (cm)',
				type: FormFieldsConstants.NUMBER
			},
			{
				name: 'car_weight_max',
				label: i18n.t('management:form.car_weight_max.title') + ' (kg)',
				type: FormFieldsConstants.NUMBER
			},
		]
	}, [] )
	
	let content = <LoadingComponent />;
	if( !loading ) {
		content = (
			<ThemedBlock
				shadow
				mediumPadding>
				
				<Form
					values={ timeslotKindLimitation }
					fields={ formFields }
					onChange={ onChange }
					onSubmit={ onSubmit }
					disabled={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.TIMESLOTS ) }
					forceSaveButton={ true }
				/>
			</ThemedBlock>
		)
	}
	
	return (
		<VStack>
			<PreviewTimeslotKind
				timeslotKind={ timeslotKind }
			/>
			
			{ content }
		</VStack>
	);
}


export default ManagementTimeslotKindLimitationsTab
